import React, { memo } from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import Button from 'components/common/button'
import styles from './styles.scss'

const BoxIcon = ({ text, isSelected, onClick }) => {
  if (!text) {
    return null
  }

  return (
    <Button
      className={clsx('box-icon', {
        '--selected': isSelected,
      })}
      onClick={!isSelected && onClick}
    >
      <style jsx>{styles}</style>
      {text}
    </Button>
  )
}

BoxIcon.propTypes = {
  text: PropTypes.string.isRequired,
  isSelected: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
}

export default memo(BoxIcon)
